import React, { useCallback, useEffect, useState } from "react";
import { message } from "antd";
import firebase from "firebase/compat/app";

import AuditTable from "./AuditTable";

const PAGE_SIZE = 50;

// Historique d'un envoi (fiche envoi du back-office, admins uniquement) : toutes les entrées
// du journal dont la cible est l'envoi ou l'un de ses destinataires, de la plus récente à la
// plus ancienne.
export default function AuditTimeline({ messageId }) {
  const [entries, setEntries] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);

  const load = useCallback(
    async (after) => {
      setLoading(true);
      try {
        let query = firebase
          .firestore()
          .collection("audit_logs")
          .where("target.message_id", "==", messageId)
          .orderBy("at", "desc")
          .limit(PAGE_SIZE);
        if (after) query = query.startAfter(after);
        const snap = await query.get();
        const page = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setEntries((previous) => (after ? [...previous, ...page] : page));
        setCursor(snap.docs[snap.docs.length - 1] || null);
        setHasMore(snap.docs.length === PAGE_SIZE);
      } catch (e) {
        console.error(e);
        message.error("Lecture de l'historique impossible");
      } finally {
        setLoading(false);
      }
    },
    [messageId]
  );

  useEffect(() => {
    load(null);
  }, [load]);

  return (
    <AuditTable
      entries={entries}
      loading={loading}
      hasMore={hasMore}
      onLoadMore={() => load(cursor)}
      showCompany={false}
    />
  );
}
